import {
  Body,
  Heading,
  Icon,
  SimpleGrid,
  Table,
  Tbody,
  Td,
  Tr,
  VStack,
  Divider,
  Box,
} from '@hover/blueprint';
import { iCheck, iX } from '@hover/icons';
import React from 'react';
import { nanoid } from 'nanoid';
import {
  IPricingFeature,
  IPricingSection,
} from '../../../../interfaces/IPricingPageTableData';
import { PRICING_TABLE_DATA } from '../../../../constants';
import HeaderCards from './HeaderCards';
import PricingTooltip from '../../plans-and-pricing/PricingTooltip';

const TableData = PRICING_TABLE_DATA.map((section: IPricingSection, index) => (
  <Tbody borderTop="none">
    <Tr borderBottomWidth="1px" borderColor="neutral.400">
      <Td py={0} style={{ paddingLeft: 0 }}>
        <Heading
          mt={index === 0 ? 0 : 800}
          marginBottom={500}
          size={500}
          fontWeight={700}
        >
          {section.sectionName}
        </Heading>
      </Td>
    </Tr>
    {section.features.map((feature: IPricingFeature) => (
      <Tr
        borderBottomWidth="1px"
        borderColor="neutral.400"
        key={feature.feature}
      >
        <SimpleGrid columns={6} spacing={600}>
          <Td d="flex" minW="322px" maxH={500} alignItems="center">
            <PricingTooltip
              minW="390px"
              pr={400}
              pl={{ base: 0, tablet: 600 }}
              tooltip={{
                id: nanoid(),
                title: feature.feature,
                tooltip: feature.tooltip,
              }}
            />
          </Td>
          <Td />
          {feature.values.map(value => (
            <Td maxH={500} d="flex" alignItems="center">
              {typeof value === 'string' ? (
                <Body textAlign="center" mx="auto" size={400}>
                  {value}
                </Body>
              ) : (
                <Icon
                  icon={value ? iCheck : iX}
                  size="default"
                  mx="auto"
                  color={value ? 'success.600' : 'brandOrange.300'}
                />
              )}
            </Td>
          ))}
        </SimpleGrid>
      </Tr>
    ))}
  </Tbody>
));

const PricingTableDesktop: React.FC = () => (
  <Box flexDir="column" d={{ base: 'none', desktop: 'flex' }} px={500}>
    <SimpleGrid mb={500} columns={2} w="100%" spacing={600}>
      <Box alignItems="center" justifyContent="flex-end">
        <VStack
          spacing={400}
          maxW="30%"
          w="100%"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Body size={600} isBold color="neutral.300">
            Pay as you go
          </Body>
          <Divider borderColor="neutral.400" />
        </VStack>
      </Box>
      <Box alignItems="center" justifyContent="center">
        <VStack spacing={400} w="100%">
          <Body size={600} isBold color="neutral.300">
            Membership
          </Body>
          <Divider borderColor="neutral.400" />
        </VStack>
      </Box>
    </SimpleGrid>
    <HeaderCards />
    <Table bg="brandTan.100" w="100%">
      {TableData}
    </Table>
  </Box>
);

export default PricingTableDesktop;
